import { useObserver } from 'mobx-react-lite';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { MENU_TYPE_REC } from 'shared/constants';
import useCart from 'src/hooks/use-cart';

export const useHideSalesLanguage = (dispensaryState?: string | null): boolean => {
  const cart = useCart();
  const menuType = useObserver(() => cart.menuType);

  return menuType === MENU_TYPE_REC && getComplianceConfig(dispensaryState, 'recHideSalesLanguage');
};
